var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxCirclePrimaryChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    fill: "#774EFF",
    stroke: "#774EFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5084 5.25275C12.8597 5.47227 12.9665 5.93497 12.7469 6.28624L8.96739 12.3342C8.96006 12.3459 8.9525 12.358 8.94513 12.3698C8.81306 12.5811 8.67382 12.8038 8.53322 12.9691C8.37354 13.1569 8.10493 13.401 7.69134 13.4251C7.27758 13.4491 6.98231 13.2374 6.80214 13.0696C6.643 12.9215 6.47872 12.716 6.32308 12.5215C6.31464 12.5109 6.30622 12.5004 6.29783 12.4899L5.30301 11.2461C5.04428 10.9227 5.09676 10.4507 5.42023 10.192C5.7437 9.93324 6.21566 9.98572 6.47439 10.3092L7.4689 11.5526C7.46885 11.5525 7.46896 11.5526 7.4689 11.5526C7.51408 11.609 7.55453 11.6595 7.59131 11.7049C7.62265 11.6555 7.65691 11.6007 7.69535 11.5393L11.4749 5.49131C11.6944 5.14004 12.1571 5.03324 12.5084 5.25275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCirclePrimaryChecked);
export default __webpack_public_path__ + "static/media/checkbox_circle_primary_checked.e82a871857cf4103052038cac8e6934c.svg";
export { ForwardRef as ReactComponent };